<template lang="pug">
div
	.alert.alert-info
		|En este apartado de extras es posible almacenar información en formato "Tipo -> valor" relacionada con el usuario.
		br
		|Por ejemplo: Huella entrada: 01
	.row.mb-2(v-for="(extra, index) in usuario.extras" :key="'extra_' + index")
		.col
			//input-query(
				input-class="form-control form-control-sm"
				@selected="extra.clave = $event.datos.clave"
				:placeholder="extra.clave"
				:realtime="true"
				url="gestion-usuarios/php/queryExtras.php")
			select.form-control(v-model="extra.clave")
				option(:value="tipo" v-for="tipo in tipos" :key="tipo") {{tipo}}
		.col
			.input-group
				input.form-control.form-control-sm(type="text" v-model="extra.valor" placeholder="Valor")
				.input-group-append
					button.btn.btn-sm.btn-danger(@click="quitarExtra(index)")
						span.fa.fa-trash
	.row
		.col.text-left
			button.btn.btn-sm.mt-2.btn-warning(@click="nuevoExtra()")
				span.fa.fa-plus.mr-2
				|Añadir
		.col.text-right
			button.btn.btn-sm.mt-2.btn-primary(@click="guardar()")
				span.fa.fa-save.mr-2
				|Guardar extras
</template>
<script>
import API from '../api'
export default {
	props: ['usuario'],
	data () {
		return {
			tipos: ['Huella entrada', 'Huella salida', 'Huella CPD']
		}
	},

	methods: {
		nuevoExtra () {
			this.usuario.extras.push({
				ID_extra: null,
				clave: '',
				valor: ''
			})
		},

		quitarExtra (i) {
			this.usuario.extras.splice(i, 1)
		},

		guardar () {
			API.setUsuario(this.usuario)
				.then(res => {
					res.data.usuario.fecha_nacimiento = (res.data.usuario.fecha_nacimiento) ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null
					res.data.usuario.caduca_password = (res.data.usuario.caduca_password) ? new Date(res.data.usuario.caduca_password * 1000) : null
					res.data.usuario.fecha_expiracion_cuenta = (res.data.usuario.fecha_expiracion_cuenta) ? new Date(res.data.usuario.fecha_expiracion_cuenta * 1000) : null

					this.$emit('update:usuario', res.data.usuario)
					this.$store.commit('alertas/alert', {
						titulo: 'Guardado',
						mensaje: 'Se ha guardado la información del usuario correctamente'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/editor/extras.vue